import React, { useState } from "react";
import ShowCards from "../../components/Cards/ShowCards/ShowCards";
import ShowBoosters from "../../components/Boosters/ShowBoosters/ShowBoosters";
import styles from "./Creator.module.css";
import { Link } from "react-router-dom";
import globalStyles from "../../styles/globalStyles.module.css";
import InfiniteScroll from "../../components/InfiniteScroll/InfiniteScroll";
import { useCreatorCardsContext } from "../../context/Creator/CreatorCardsProvider";
// import FilterCards from "../../components/Cards/FilterCards/FilterCards";
import { useCreatorBoostersContext } from "../../context/Creator/CreatorBoostersProvider";
import { ShowCardsType } from "../../services/CardServices";
import FilterBoosters from "../../components/Boosters/FilterBoosters/FilterBoosters";
import { boosterData } from "../../services/BoosterServices";
import { useTranslation } from "react-i18next";

export enum CreatorViewMode {
  cards = 1,
  boosters = 2,
}

interface CreatorProps {
  viewModeValue?: CreatorViewMode;
}

const Forge: React.FC<CreatorProps> = ({
  viewModeValue = CreatorViewMode.cards,
}) => {
  const [viewMode, setViewMode] = useState(viewModeValue.valueOf()); // Default selected value
  const { cardsState } = useCreatorCardsContext();
  const creatorBoosterContext = useCreatorBoostersContext();
  const { t } = useTranslation();

  const radios = [
    { name: t("cards.label"), value: 1, page: "cards" },
    { name: t("boosters.label"), value: 2, page: "boosters" },
  ];

  const toggleBoosterPage = () => {
    creatorBoosterContext.boostersState.setPage((prev) => prev + 1);
  };

  const handleAddOrRemoveCards = (cards: ShowCardsType[]) => {
    cardsState.setFilteredData(cards);
  };

  const handleAddOrRemoveBoosters = (boosters: boosterData[]) => {
    creatorBoosterContext.setFilteredBoosters(boosters);
  };

  const contentMap: { [key: number]: JSX.Element } = {
    1: (
      <InfiniteScroll
        key={1}
        togglePage={cardsState.togglePage}
        loading={cardsState.loading}
        hasMore={cardsState.hasMore}
      >
        {/* <FilterCards
          cards={cardsState.data}
          handleFilterCards={cardsState.setFilteredData}
        /> */}
        {cardsState.data.length === 0 ? (
          <div className={globalStyles.center}>{t("noContent")}</div>
        ) : (
          <ShowCards
            cards={cardsState.filteredData}
            disableDelete={false}
            handleAddOrRemoveCards={handleAddOrRemoveCards}
          />
        )}
      </InfiniteScroll>
    ),
    2: (
      <InfiniteScroll
        key={2}
        togglePage={toggleBoosterPage}
        loading={creatorBoosterContext.boostersState.loading}
        hasMore={creatorBoosterContext.boostersState.hasMore}
      >
        <FilterBoosters
          boosters={creatorBoosterContext.boostersState.data}
          handleFilterBoosters={creatorBoosterContext.setFilteredBoosters}
        />
        {creatorBoosterContext.boostersState.data.length === 0 ? (
          <div className={globalStyles.center}>{t("noContent")}</div>
        ) : (
          <ShowBoosters
            boosters={creatorBoosterContext.filteredBoosters}
            showInStore={false}
            handleAddOrRemoveBoosters={handleAddOrRemoveBoosters}
            disableDelete={false}
          />
        )}
      </InfiniteScroll>
    ),
  };

  return (
    <div>
      <div className={globalStyles.pageTitle}>{t("creator.label")}</div>
      <div className={styles.buttonGroup}>
        {radios.map((radio, index) => (
          <Link
            to={`/creator/${radio.page}`}
            className={styles.none}
            key={index}
          >
            <div
              key={index}
              className={`${styles.toggleButton} ${
                radio.value === viewMode ? styles.active : ""
              }`}
              onClick={() => setViewMode(radio.value)}
            >
              {radio.name}
            </div>
          </Link>
        ))}
      </div>

      {contentMap[viewMode]}
    </div>
  );
};

export default Forge;
